import React from "react"

export const NotFound = () => {
    document.body.style.background = '#111827'
    return (
        <React.Fragment>
              <div class="absolute left-20 top-10 w-52 h-52 bg-[#9715D9] blur-[80px]"></div>
                <div class="absolute left-72 top-72 w-52 h-52 bg-[#DA145F] blur-[80px]"></div>
                <div class="absolute left-20 top-96 w-52 h-52 bg-[#F71135] blur-[80px]"></div>
                <div class="absolute right-20 top-10 w-52 h-52 bg-[#3C45FA] blur-[80px]"></div>
                <div class="absolute right-52 top-72 w-52 h-52 bg-[#7E1FF9] blur-[80px]"></div>
            
                <div  class="relative z-50 w-full h-screen flex flex-col items-center justify-center text-white">
                    <p class="font-bold text-7xl">404</p>
                    <p className="text-4xl">Not Found</p>
                </div>
        </React.Fragment>
    )
}